import { render, staticRenderFns } from "./ProductUpdate.vue?vue&type=template&id=7e66c45d&scoped=true"
import script from "./ProductUpdate.vue?vue&type=script&lang=js"
export * from "./ProductUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e66c45d",
  null
  
)

export default component.exports